import React, { useState, useEffect } from "react";
import { openOAuthPopup } from "../../../utils/oauthPopup";
import { getAuthorizeUrl } from "../../../config/oauth";


const CannoctSocalAccounts = () => {
    const [accounts, setAccounts] = useState([
        { key: "facebook", name: "Facebook", icon: "ti-facebook", connected: false, username: "" },
        { key: "instagram", name: "Instagram", icon: "ti-instagram", connected: false, username: "" },
        { key: "twitter", name: "Twitter / X", icon: "ti-twitter-alt", connected: false, username: "" },
        { key: "linkedin", name: "LinkedIn", icon: "ti-linkedin", connected: false, username: "" },
        { key: "youtube", name: "YouTube", icon: "ti-youtube", connected: false, username: "" }
    ]);

    const handleConnect = async (key) => {
        if (key === "facebook") {
            try {
                const authorizeUrl = await getAuthorizeUrl("facebook");
                const result = await openOAuthPopup(authorizeUrl, { name: "FacebookLogin" });
                console.log("getRedirectUri base url result :", result);
                // result.code contains the authorization code; exchange on server for access token
                setAccounts((prev) => prev.map((acc) => acc.key === key ? { ...acc, connected: true, username: "@facebook" } : acc));
            } catch (e) {
                console.error(e);
                alert(e.message || "Failed to connect Facebook.");
            }
            return;
        }
        setAccounts((prev) => prev.map((acc) => acc.key === key ? { ...acc, connected: true, username: `@${acc.name.toLowerCase().replace(/\s\/\s|\s+/g, "_")}` } : acc));
    };

    const handleDisconnect = (key) => {
        setAccounts((prev) => prev.map((acc) => acc.key === key ? { ...acc, connected: false, username: "" } : acc));
    };

    return (
        <div className="dc-tabscontent tab-content">
            <div className="dc-securityhold tab-pane active fade show" id="dc-security">
                <div className="dc-securitysettings dc-tabsinfo dc-tabsinfo-mt">
                    <div className="dc-tabscontenttitle">
                        <h3>Connect Social Accounts</h3>
                    </div>
                    <div className="dc-settingscontent dc-sidepadding d-flex flex-column gap-4">
                        <div className="dc-description">
                            <p>Link your social profiles to showcase authenticity and enable quick sharing.</p>
                        </div>

                        <ul className="dc-list dc-listvtwo">
                            {accounts.map((acc) => (
                                <li key={acc.key} className="dc-listitem" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '16px', padding: '12px 0', borderBottom: '1px solid #f2f2f2' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                        <span className={`dc-iconbox new-iconbox`} style={{ width: 40, height: 40, borderRadius: '50%', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', background: '#f7f7f7' }}>
                                            <i className={acc.icon}></i>
                                        </span>
                                        
                                        <div style={{ height: '40px',width: '0.1px',background: '#00000042',boxShadow: '0px 0px 6px black' }}></div>
                                        
                                        <div>
                                            <h4 style={{ margin: 0 }}>{acc.name}</h4>
                                            {acc.connected ? (
                                                <small style={{ color: '#28a745' }}>Connected as <strong>{acc.username}</strong></small>
                                            ) : (
                                                <small style={{ color: '#999' }}>Not connected</small>
                                            )}
                                        </div>
                                    </div>

                                    <div>
                                        {acc.connected ? (
                                            <button type="button" className="dc-btn" onClick={() => handleDisconnect(acc.key)}>
                                                Disconnect
                                            </button>
                                        ) : (
                                            <button type="button" className="dc-btn" onClick={() => handleConnect(acc.key)}>
                                                Connect
                                            </button>
                                        )}
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CannoctSocalAccounts;
